const features = [
  {
    title: '热血漫专题：燃爆这个夏天',
    desc: '精选百部高分热血全本漫画，从《星辰变》到《一人之下》，完整版一次性畅读，感受最纯粹的漫画热血与激情。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20style%20illustration%20with%20explosive%20energy%20effects%20and%20warm%20fiery%20coral%20background%2C%20bold%20motion%20lines%2C%20adventure%20theme%2C%20vibrant%20intense%20colors%2C%20heroic%20atmosphere%2C%20Japanese%20anime%20inspired%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '恋爱漫特辑：甜蜜心动瞬间',
    desc: '从校园到古风，最动人的恋爱全本漫画合集。韩漫精致画风搭配细腻情感，每一页都是心动的感觉，免费完整版尽在樱花漫画网。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20soft%20manga%20style%20illustration%20with%20cherry%20blossom%20petals%20and%20warm%20pink%20coral%20gradient%2C%20dreamy%20atmospheric%20lighting%2C%20sweet%20gentle%20mood%2C%20love%20theme%2C%20elegant%20Japanese%20anime%20aesthetic%2C%20soft%20focus%20background&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '韩漫精品馆：高颜值画风盛宴',
    desc: '汇聚全网最受欢迎的韩漫全本漫画作品，精致的画风、深刻的剧情，每一部都是视觉与故事的双重享受。樱花漫画网完整版免费阅读。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20style%20illustration%20with%20ornate%20palace%20architecture%20and%20flowing%20fabrics%2C%20soft%20rose%20gold%20and%20amber%20gradient%20background%2C%20refined%20artistic%20composition%2C%20royal%20historical%20fantasy%20theme%2C%20luxurious%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '日漫经典馆：不朽的漫画传奇',
    desc: '重温那些年陪伴我们成长的日漫经典全本漫画。从热血冒险到悬疑推理，日漫全集完整版下拉式阅读，经典永不褪色。樱花漫画网独家整理。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Japanese%20manga%20style%20illustration%20with%20nostalgic%20warm%20sepia%20and%20amber%20tones%2C%20traditional%20Japanese%20elements%20blending%20with%20modern%20aesthetic%2C%20vintage%20atmosphere%2C%20timeless%20adventure%20theme%2C%20elegant%20minimalist%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '国漫新势力：崛起中的东方美学',
    desc: '国漫崛起势不可挡，从《一人之下》到《星辰变》，全本漫画完整版集合了最优秀的国产漫画作品。下拉式流畅阅读，感受国漫的独特魅力。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20ink%20wash%20painting%20style%20illustration%20with%20modern%20twist%2C%20mountains%20and%20flowing%20water%20landscape%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20traditional%20oriental%20aesthetic%20blended%20with%20contemporary%20design%2C%20majestic%20atmosphere&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选五大专题，深度发现好看的全集漫画
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer ${
                idx === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className={`flex flex-col ${idx === 0 ? 'md:flex-row' : ''}`}>
                <div className={`overflow-hidden ${idx === 0 ? 'md:w-1/2' : ''}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                      idx === 0 ? 'h-56 md:h-full' : 'h-48'
                    }`}
                  />
                </div>
                <div className={`p-5 md:p-6 ${idx === 0 ? 'md:w-1/2' : ''}`}>
                  <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  <span className="inline-block mt-4 text-sm text-primary-600 font-medium whitespace-nowrap">
                    探索专题 <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}